import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DenunciarPage } from './denunciar';

const routes: Routes = [
  {
    path: '',
    component: DenunciarPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DenunciarPageRoutingModule { }
